import {Trans} from '@lingui/macro';
import React from 'react';

import {ActivityModel, ActivityVisualTypesEnum} from '../../../models/api/activityModel';
import {ActivitySourceVisualTypesEnum} from '../../../models/api/activitySourceModel';

export function computeAutoResponsePillText(
  activitySourceVisualType: ActivitySourceVisualTypesEnum | undefined,
) {
  // We intend to change this text to "Out of office reply" in the future.
  //  See https://paper.dropbox.com/doc/Design-spec-Inconspicuous-auto-responders--BekVDBYQJ~xtvZE9330NJFVWAg-n3c0LLeF8JMwggZNf1pVh.
  if (activitySourceVisualType === ActivitySourceVisualTypesEnum.OUT_OF_OFFICE_REPLY) {
    return <Trans id="auto-response-out-of-office-reply">Vacation responder</Trans>;
  }

  if (activitySourceVisualType === ActivitySourceVisualTypesEnum.AUTOMATED_REPLY) {
    return <Trans id="auto-response-automated-reply">Automated Reply</Trans>;
  }

  return null;
}

export function computeMessageActivitySourceVisualType(
  activity: ActivityModel,
): ActivitySourceVisualTypesEnum | undefined {
  return activity.visualType === ActivityVisualTypesEnum.MESSAGE ? activity.source?.visualType : undefined;
}

export function computeIsAutoResponseMessageActivitySource(
  activitySourceVisualType: ActivitySourceVisualTypesEnum | undefined,
) {
  return (
    activitySourceVisualType === ActivitySourceVisualTypesEnum.OUT_OF_OFFICE_REPLY ||
    activitySourceVisualType === ActivitySourceVisualTypesEnum.AUTOMATED_REPLY
  );
}
